// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Map from '../_raw/ui/icon_map.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Map);
